<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Takeover" class="d-icon d-icon--takeover" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12"><g :clip-path="`url(#${uniqueID}a)`"><path fill="currentColor" fill-rule="evenodd" d="M9.072 1.25a6.866 6.866 0 0 0-1.136 1.761l1.18.107a.043.043 0 0 0 .041-.02l.644-1.073a.043.043 0 0 0-.007-.052l-.722-.722ZM7.584 3.984l1.442.13c.399.037.783-.158.989-.501l.643-1.072c.246-.41.182-.936-.157-1.274L9.778.543C9.4.165 8.751.115 8.348.56a7.972 7.972 0 0 0-2.024 5.337c-.001 2.746 1.33 4.761 1.996 5.6.39.491 1.082.47 1.484.068l.698-.698c.339-.339.403-.864.157-1.275l-.664-1.104a1.043 1.043 0 0 0-.894-.506H7.618a7.577 7.577 0 0 1-.294-2.084c0-.71.102-1.35.26-1.915Zm.392 5a8.53 8.53 0 0 0 1.117 1.879.059.059 0 0 0 .004-.004l.698-.698a.043.043 0 0 0 .007-.053l-.664-1.104a.043.043 0 0 0-.037-.02H7.976ZM3.162 3.898a.5.5 0 0 1 .707 0l1.809 1.809a.5.5 0 0 1 0 .707L3.869 8.222a.5.5 0 0 1-.707-.707l.955-.955h-2.41a.5.5 0 1 1 0-1h2.41l-.955-.954a.5.5 0 0 1 0-.708Z" clip-rule="evenodd"/></g><defs><clipPath :id="`${uniqueID}a`"><path fill="#fff" d="M0 0h12v12H0z"/></clipPath></defs></svg>
</template>

<script>
import { getUniqueString } from '@/src/utils';
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconTakeover',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
    this.uniqueID = getUniqueString();
  },
};
</script>
